<template>
    <b-tab title="PMH">
        <template v-for="plugin in plugins">
            <template v-if="isPhysician || checkUserPermission(plugin.permission_key, 'can_view')">
                <h6><i class="fa-solid" :class="plugin.icon"></i> {{ plugin.title }}</h6>
                <component :is="'pmh-' + plugin.key" :key="plugin.key" :limit="3"></component>
            </template>
        </template>
    </b-tab>
</template>
<script>
import PMHExtension from "@/core/components/pmh/PMHExtension"
import { mapActions } from "vuex"

export default PMHExtension.extend({
    name: "patient-pmh",
    methods: {
        ...mapActions('health', [
            'getHistoryForCurrentPatient', 'getAllergiesForCurrentPatient', 'getBloodTypeForCurrentPatient',
            'getVitalsForCurrentPatient', 'getMeasurementsForCurrentPatient', 'getAttestsForCurrentPatient',
        ]),
        ...mapActions('lab', [
            'getDiagnosticsForCurrentPatient',
        ]),
        ...mapActions('vaccinations', [
            'getVaccinationsForCurrentPatient',
        ]),
        ...mapActions('procedures', [
            'getProceduresForCurrentPatient',
        ]),
        ...mapActions('prescriptions', [
            'getPrescriptionsForCurrentPatient',
        ]),
        ...mapActions('patients', [
            'getMedicalCardsForCurrentPatient',
        ]),
        ...mapActions('decursus', [
            'getDecursusForCurrentPatient',
        ]),
        ...mapActions('referrals', [
            'getReferralsForCurrentPatient',
        ]),
        ...mapActions('episodes', [
            'getEpisodesForCurrentPatient',
        ]),
        async loadForPatient(patient) {
            await this.getHistoryForCurrentPatient()
            await this.getAllergiesForCurrentPatient()
            await this.getBloodTypeForCurrentPatient()
            await this.getVitalsForCurrentPatient()
            await this.getMeasurementsForCurrentPatient()
            await this.getAttestsForCurrentPatient()

            await this.getDiagnosticsForCurrentPatient()
            await this.getPrescriptionsForCurrentPatient()
            await this.getProceduresForCurrentPatient()
            await this.getVaccinationsForCurrentPatient()
            await this.getDecursusForCurrentPatient()
            await this.getReferralsForCurrentPatient()
            await this.getEpisodesForCurrentPatient()
            await this.getMedicalCardsForCurrentPatient()
        }
    }
})
</script>